import React from 'react'
import "./index.css"

const EventErrorPopUp = ({ completePrevious, discard }) => {
    return (
        <div className="popup-container">
            <div className="popup-content">
                <h3>Complete or Discard Previous Booking</h3>
                <p>You have an ongoing booking for another event. Please complete that booking first or discard it to continue.</p>
                <div className="popup-buttons">
                    <button onClick={completePrevious} >Complete Previous Booking</button>
                    <button onClick={discard}  >Discard Previous One</button>
                </div>
            </div>
        </div>
    )
}

export default EventErrorPopUp